import _ from 'lodash';

export default {
  setIsEnabled(state, value) {
    state.isEnabled = value;
    if (!value) {
      state.selectedItems = [];
    }
  },

  setSelectedItems(state, { items }) {
    state.selectedItems = items;
  },

  removeSelectedItems(state, { items }) {
    state.selectedItems = _.difference(state.selectedItems, items);
  }
};
